import {
  getStatements,
  downloadStatement,
  downloadStatementCSV,
  downloadVehiclesCSV,
  sendStatementEmail
} from '../services/dashboardService'

import types from './types'

const { UPDATE_STATEMENTS, RESET_STATEMENTS } = types

export function fetchDashboardStatements(planId, next, filter) {
  return dispatch =>
    getStatements(planId, next, filter).then(statements => {
      if (statements.status === 204) {
        console.log('statements status -> ', status)
      } else {
        dispatch({
          type: UPDATE_STATEMENTS,
          data: statements.data,
          total: statements.total,
          monthlyTotal: statements.monthlyTotal,
          filter: filter,
          next: statements.next,
          updatedOn: statements.updatedOn,
          hasNext: statements.hasNext,
          enviarExtratoEmail: statements.enviarExtratoEmail
        })
      }
    })
}

export function downloadStatementFile(planId, filter) {
  return () => downloadStatement(planId, filter)
}

export function downloadStatementFileCSV(planId, filter) {
  return () => downloadStatementCSV(planId, filter)
}

export function resetDashboardStatements() {
  return dispatch =>
    dispatch({
      type: RESET_STATEMENTS
    })
}

export function sendStatementemail(planId, email, filter, formato) {
  return () => sendStatementEmail(planId, email, filter, formato)
}

export function downloadVehiclesFileCSV(planId) {
  return () => downloadVehiclesCSV(planId)
}



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchDashboardStatements.js